// Shared Framer Motion variants and small helpers.
export const easeOut = [0.19, 1, 0.22, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 1, ease: easeOut, delay: i * 0.08 },
  }),
};

export const lineReveal = {
  hidden: { y: "110%" },
  visible: (i = 0) => ({
    y: "0%",
    transition: { duration: 1.1, ease: easeOut, delay: 0.15 + i * 0.12 },
  }),
};

export const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

// Site content (French professional placeholder copy)
export const NAV_LINKS = [
  { to: "/a-propos", label: "À propos" },
  { to: "/expertises", label: "Expertises", dropdown: "expertises" },
  { to: "/approche-gouvernance-projets", label: "Approche" },
  { to: "/secteurs", label: "Secteurs", dropdown: "secteurs" },
  { to: "/observatoire", label: "Observatoire HERUS" },
  { to: "/contact", label: "Contact" },
];

export const LEGAL_LINKS = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/confidentialite", label: "Politique de confidentialité" },
  { to: "/cookies", label: "Gestion des cookies" },
  { to: "/cgu", label: "Conditions générales d'utilisation" },
];

export const LOGO_URL = `${process.env.PUBLIC_URL}/herus-logo.png`;

export const IMAGES = {
  founderReal: `${process.env.PUBLIC_URL}/founder.webp?v=3`,
  heroBridge:
    "https://images.unsplash.com/photo-1533852990198-bdd4082bf8c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  solarPlant:
    "https://images.unsplash.com/photo-1629726797843-618688139f5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  institutionalBuilding:
    "https://images.unsplash.com/photo-1689366154849-b8e58a995fbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  parliamentGold:
    "https://images.unsplash.com/photo-1719918508801-0dd00797d959?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  factoryAuto:
    "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  netAbstract:
    "https://static.prod-images.emergentagent.com/jobs/8ad1037f-b4c7-4e49-85d1-a30883724953/images/2d9724f7589956b28a455e74c3dd3c2cbe4bda6793235ac0116ebef06cfedff1.png",
  networkNight:
    "https://images.unsplash.com/photo-1768463851921-57671cbbe266?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  geoAbstract:
    "https://static.prod-images.emergentagent.com/jobs/8ad1037f-b4c7-4e49-85d1-a30883724953/images/784f59140859408a9f80e33546fe2f439b107fb8d7e68ef5e9adc4245493e346.png",
  citySkylineDusk:
    "https://images.unsplash.com/photo-1758609179675-a284dc57fd7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interchangeAerial:
    "https://images.unsplash.com/photo-1723698882852-24295cd67fcb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  windGolden:
    "https://images.unsplash.com/photo-1662307414752-dd37cd10a439?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  skyscraperGold:
    "https://images.unsplash.com/photo-1782852036326-9e4926c9d78d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  damAerial:
    "https://images.unsplash.com/photo-1606050309588-741702cceb9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  industrial:
    "https://images.unsplash.com/photo-1783393216247-5e054a75561b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  industrialNight:
    "https://images.unsplash.com/photo-1768128834406-f5b1b962af9d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bridge:
    "https://images.unsplash.com/photo-1529926691761-20fb82067c71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bridgeAerial:
    "https://images.unsplash.com/photo-1515674744565-0d7112cd179a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  heroInfra:
    "https://images.unsplash.com/photo-1543489816-c87b0f5f7dd4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  towersGreen:
    "https://images.unsplash.com/photo-1413882353314-73389f63b6fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pylonsSunset:
    "https://images.unsplash.com/photo-1610028290816-5d937a395a49?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  truss:
    "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cityAerial:
    "https://images.unsplash.com/photo-1596564309076-01c1868b07a4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cityDusk:
    "https://images.unsplash.com/photo-1597285952775-1382215fbff0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  solar:
    "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  solarField:
    "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  governance:
    "https://images.unsplash.com/photo-1600540984005-c7f3a641fbe5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  structure:
    "https://images.unsplash.com/photo-1488972685288-c3fd157d7c7a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  founder:
    "https://images.unsplash.com/photo-1781888681811-332968760c2a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

// Four expertise pillars — used by the Expertises overview, the detail pages and the nav dropdown.
export const EXPERTISES_DATA = [
  {
    slug: "gouvernance-projets-strategiques",
    num: "01",
    navLabel: "Gouvernance des projets stratégiques",
    title: "Gouvernance des projets stratégiques",
    lead: "Créer les conditions d'une décision efficace, transparente et durable.",
    intro:
      "Nous concevons les dispositifs de gouvernance qui permettent aux projets et aux organisations de décider vite et juste, en alignant durablement les parties prenantes autour d'objectifs partagés.",
    body: [
      "La gouvernance n'est pas une contrainte administrative : c'est le système nerveux d'un projet. Elle détermine qui décide, sur quelles bases, avec quelle information et quelle redevabilité. Lorsqu'elle est bien conçue, elle sécurise l'exécution et renforce la confiance des parties prenantes.",
      "Nous auditons les dispositifs existants, clarifions les rôles et les responsabilités, et installons des cadres de décision robustes, adaptés à la complexité institutionnelle, technique et financière de chaque projet — y compris dans le cadre exigeant des partenariats public-privé.",
    ],
    points: [
      "Diagnostic de gouvernance",
      "Audit organisationnel",
      "Cadres de décision et de redevabilité",
      "Gestion des parties prenantes",
      "Renforcement institutionnel",
      "Gouvernance des PPP",
    ],
    img: IMAGES.parliamentGold,
    alt: "Architecture institutionnelle contemporaine — gouvernance et décision",
  },
  {
    slug: "structuration-projets-ppp",
    num: "02",
    navLabel: "Structuration de projets & PPP",
    title: "Structuration de projets & PPP",
    lead: "Donner aux projets les conditions de leur réussite durable.",
    intro:
      "Nous concevons des dispositifs de gouvernance qui sécurisent la prise de décision, clarifient les responsabilités et alignent durablement les parties prenantes autour d'objectifs partagés.",
    body: [
      "La réussite d'un projet se joue en amont. Une structuration rigoureuse — cadrage stratégique, montage institutionnel, juridique et financier, allocation équilibrée des risques — conditionne sa solidité et sa capacité à mobiliser durablement les ressources.",
      "Nous accompagnons les autorités publiques, les développeurs et les investisseurs dans la préparation des projets et la structuration des PPP, en articulant gouvernance, intérêt public et soutenabilité, pour des montages robustes et alignés sur le long terme.",
    ],
    points: [
      "Diagnostic stratégique",
      "Structuration des projets",
      "Gouvernance des projets",
      "Structuration des PPP",
      "Allocation des risques",
      "Préparation à la décision",
    ],
    img: IMAGES.interchangeAerial,
    alt: "Échangeur autoroutier vu du ciel — structuration de projets d'infrastructures",
  },
  {
    slug: "impact-performance",
    num: "03",
    navLabel: "Impact & Performance",
    title: "Impact & Performance",
    lead: "Mesurer la valeur, au-delà de la seule réalisation.",
    intro:
      "Nous développons des cadres d'évaluation et de suivi qui inscrivent l'impact, la performance et la création de valeur durable au cœur de chaque projet.",
    body: [
      "Un projet ne se juge pas à sa livraison, mais à la valeur qu'il crée dans la durée. Nous concevons des indicateurs et des dispositifs de suivi qui rendent visibles les résultats économiques, sociaux et environnementaux, et qui nourrissent la décision.",
      "En plaçant la mesure d'impact et la redevabilité au centre, nous aidons les organisations et leurs bailleurs à éclairer leurs décisions, à démontrer leurs résultats et à améliorer continûment leur performance collective.",
    ],
    points: [
      "Indicateurs d'impact",
      "Indicateurs de performance",
      "Cadres de suivi et de reporting",
      "Redevabilité et transparence",
      "Création de valeur durable",
      "Aide à la décision",
    ],
    img: IMAGES.damAerial,
    alt: "Barrage hydroélectrique vu du ciel — impact et performance des infrastructures",
  },
  {
    slug: "transition-energetique-transformation",
    num: "04",
    navLabel: "Transition énergétique & Transformation",
    title: "Transition énergétique & Transformation",
    lead: "Accompagner les mutations qui façonneront les systèmes de demain.",
    intro:
      "Nous soutenons les projets de décarbonation et les nouvelles filières énergétiques, et accompagnons les organisations dans leurs transformations stratégiques et opérationnelles.",
    body: [
      "La transition énergétique redessine les modèles industriels et territoriaux. Décarbonation, hydrogène, gaz renouvelables, CCUS : ces filières exigent de concilier ambition environnementale, faisabilité technique et modèle économique viable.",
      "Au-delà des projets, nous accompagnons les organisations dans la conduite du changement et le renforcement de leurs capacités d'exécution, pour transformer durablement leurs pratiques et leur performance.",
    ],
    points: [
      "Décarbonation industrielle",
      "Hydrogène et gaz renouvelables",
      "Gaz industriels et CCUS",
      "Infrastructures énergétiques",
      "Transformation des organisations",
      "Conduite du changement",
    ],
    img: IMAGES.windGolden,
    alt: "Parc éolien à l'heure dorée — transition énergétique et infrastructures de demain",
  },
];

// Four intervention sectors — one page with anchors, referenced by the nav dropdown.
export const SECTEURS_DATA = [
  {
    id: "energie",
    n: "01",
    navLabel: "Énergie",
    t: "Énergie & Transition énergétique",
    d: "Accompagner le développement de systèmes énergétiques durables, résilients et performants, en soutenant les projets de décarbonation, les nouvelles filières énergétiques et les infrastructures de demain.",
    img: IMAGES.windGolden,
  },
  {
    id: "infrastructures",
    n: "02",
    navLabel: "Infrastructures",
    t: "Infrastructures & Développement territorial",
    d: "Contribuer à la conception, à la structuration et à la gouvernance de projets d'infrastructures créateurs de valeur économique, sociale et environnementale pour les territoires.",
    img: IMAGES.interchangeAerial,
  },
  {
    id: "industrie",
    n: "03",
    navLabel: "Industrie",
    t: "Industrie & Transformation",
    d: "Accompagner les organisations industrielles dans leurs transformations stratégiques, l'amélioration de leur performance et l'adaptation aux mutations technologiques, énergétiques et organisationnelles.",
    img: IMAGES.industrial,
  },
  {
    id: "secteur-public",
    n: "04",
    navLabel: "Secteur public",
    t: "Secteur public & Institutions",
    d: "Renforcer les capacités des institutions publiques dans la gouvernance, la structuration et le pilotage de projets au service de l'intérêt général et du développement durable.",
    img: IMAGES.institutionalBuilding,
  },
];
